import { isAllowedOrigin, type Environment } from './allowlist';

export type Provider = 'google' | 'saml' | 'oidc';

export interface BridgeParams {
  provider: Provider;
  parentOrigin: string;
  providerId?: string;
  tenantId?: string;
}

export type ParseResult =
  | { ok: true; params: BridgeParams }
  | { ok: false; error: 'auth_failed' };

const PROVIDER_VALUES: ReadonlyArray<Provider> = ['google', 'saml', 'oidc'];
const TENANT_ID_PATTERN = /^[A-Za-z0-9_-]{1,128}$/;
const PROVIDER_ID_PATTERN = /^[A-Za-z0-9._-]{1,128}$/;

export function parseAndValidateParams(search: string, env: Environment): ParseResult {
  const params = new URLSearchParams(search);

  const provider = params.get('provider');
  if (!provider || !PROVIDER_VALUES.includes(provider as Provider)) {
    return { ok: false, error: 'auth_failed' };
  }

  const parentOrigin = params.get('parentOrigin');
  if (!parentOrigin || !isAllowedOrigin(parentOrigin, env)) {
    return { ok: false, error: 'auth_failed' };
  }

  const providerId = params.get('providerId') ?? undefined;
  const tenantId = params.get('tenantId') ?? undefined;

  if (provider === 'saml' || provider === 'oidc') {
    if (!providerId || !PROVIDER_ID_PATTERN.test(providerId)) {
      return { ok: false, error: 'auth_failed' };
    }
    if (!tenantId || !TENANT_ID_PATTERN.test(tenantId)) {
      return { ok: false, error: 'auth_failed' };
    }
  }

  if (tenantId !== undefined && !TENANT_ID_PATTERN.test(tenantId)) {
    return { ok: false, error: 'auth_failed' };
  }

  return {
    ok: true,
    params: { provider: provider as Provider, parentOrigin, providerId, tenantId },
  };
}
